/** Shown when map layer data fails to load (panel + layer row). */
export const MAP_DATA_LOAD_ERROR_HINT =
  "couldn't load map data — specify your request more clearly, try a better model, or contact support if this persists";

/** Shown when the browser cannot create the WebGL context MapLibre needs. */
export const MAP_WEBGL_UNAVAILABLE_MESSAGE =
  "This browser couldn't draw the map. Graphics acceleration may be turned off.";
